import { render, staticRenderFns } from "./CuposLiberarCupos.vue?vue&type=template&id=286c0faa"
import script from "./CuposLiberarCupos.vue?vue&type=script&lang=js"
export * from "./CuposLiberarCupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports